import * as React from 'react';

import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react';

export type RadioProps = {
	rootRef?:    React.Ref<HTMLDivElement>;
	inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
} & ChakraRadioGroup.ItemProps;

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
	(props, ref) => {
		const {
			children, inputProps, rootRef, ...rest
		} = props;

		return (
			/* @ts-ignore */
			<ChakraRadioGroup.Item ref={rootRef} {...rest}>
				<ChakraRadioGroup.ItemHiddenInput ref={ref} {...inputProps} />
				<ChakraRadioGroup.ItemIndicator />
				{children
				&& <ChakraRadioGroup.ItemText>{children}</ChakraRadioGroup.ItemText>}
			</ChakraRadioGroup.Item>
		);
	},
);

Radio.displayName = 'Radio';

export const RadioGroup = ChakraRadioGroup.Root;
